var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("aside", { class: _vm.classes }, [
    _c("div", { class: _vm.prefixClass + "__header" }, [
      _c("div", { class: _vm.prefixClass + "__logo" }, [
        _vm.title
          ? _c("span", [_vm._v("\n        " + _vm._s(this.title) + "\n      ")])
          : _c("span", [_vm._t("logo")], 2)
      ])
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.prefixClass + "__body" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a5c856e", { render: render, staticRenderFns: staticRenderFns })
  }
}